import {Defaults} from "@react-three/uikit-apfel";
import {Fullscreen, Root} from "@react-three/uikit";
import React, {useRef} from "react";
import {WSReconnectUI} from "./WSReconnectUI.js";
import {useFrame, useThree} from "@react-three/fiber";
import * as THREE from "three";
import {observer_mgl_r3} from "../../../../Utils/ThreeJS/General.js";
import {store} from "../../../../Store/index.js";

export const VRUIRoot = observer_mgl_r3(()=>{
	const groupRef = useRef<THREE.Group>(null);
	const {camera} = useThree();
	const vrState = store.main.tools.vr;

	useFrame(()=>{
		const group = groupRef.current;
		// have the group follow the camera
		if (group == null) return;
		const camWorldPos = new THREE.Vector3();
		camera.getWorldPosition(camWorldPos);

		// set position to be 1m in front of the camera
		/*const camDir = new THREE.Vector3();
		camera.getWorldDirection(camDir);
		const posOffsetFromCam = new THREE.Vector3().copy(camDir).normalize().multiplyScalar(2); // X-meters in front of camera
		posOffsetFromCam.y -= 1; // also move target-pos down a bit (we don't want it in the center of the view)
		group.position.copy(camWorldPos).add(posOffsetFromCam);
		//group.lookAt(camWorldPos);*/

		const camDir = new THREE.Vector3();
		camera.getWorldDirection(camDir);
		camDir.z = 0; // ignore vertical direction (z-up: so that offset is only in the horizontal plane)
		camDir.normalize();
		const posOffsetFromCam = new THREE.Vector3().copy(camDir).normalize().multiplyScalar(3); // X-meters in front of camera
		group.position.copy(camWorldPos).add(posOffsetFromCam);
		// just set UI to be on the floor for now...
		group.position.z = .25 + .1; // +0.1 offset is because floor is not exactly at 0 height (I think)
		// Extract z-rotation (yaw about the vertical axis) from camera and apply it to the group
		const euler = new THREE.Euler().setFromQuaternion(camera.quaternion, "ZXY");
		group.rotation.set(0, 0, euler.z);
		// change rotation from "standing straight up", to instead be halfway between "flat on the floor" and "standing straight up"
		//group.rotation.x = -Math.PI / 4; // rotate 45 degrees down
		group.updateMatrixWorld();
	});

	if (!vrState.showUI && store.wvc.webSocketConnected) return null;

	return (
		<group ref={groupRef} position={[0, 0, 2]}>
			<Defaults>
				{/*<Fullscreen overflow="scroll" scrollbarColor="black" backgroundColor="white" dark={{ backgroundColor: "black" }} flexDirection="column" gap={32} paddingX={32} alignItems="center" padding={32}>*/}
				{/* regarding size/pixel-size, see here: https://pmndrs.github.io/uikit/docs/tutorials/sizing */}
				<Root sizeX={3} sizeY={.5} pixelSize={.01} flexDirection="row">
					<WSReconnectUI/>
				</Root>
			</Defaults>
		</group>
	);
});